import { gql } from '@apollo/client';

export const MUTATION = gql`
  mutation DeleteMemberSeasonParticipants(
    $organizationId: ID!
    $deleteMemberSeasonParticipants: [DeleteMemberSeasonParticipantsInput]!
  ) {
    deleteMemberSeasonParticipants(
      organizationId: $organizationId
      deleteMemberSeasonParticipants: $deleteMemberSeasonParticipants
    ) {
      seasonParticipantId
      seasonParticipantType
    }
  }
`;
